// Added by Sejune Oh on 2020-03-02
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Collapse as MaterialUICollapse,
    CollapseProps as MaterialUICollapseProps
} from '@material-ui/core'

interface CollapseBaseProps { }
export type CollapseProps = Partial<MaterialUICollapseProps> & CollapseBaseProps

export const Collapse: FC<CollapseProps> = ({ ...props }) => {
    return <MaterialUICollapse {...props}></MaterialUICollapse>
}
